import { Modal, Image } from "semantic-ui-react"
import InstacartIcon from "../../../images/instacart-icon.svg"
import CarAdviseInstacartLogo from "../../../images/caradvise-instacart-logo.svg"
import React, { useEffect, useState } from "react"
import { getQuarterEndDate } from "../../../v1/helpers/dateHelpers"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { routerPaths } from "../../../v1/constants/paths"
import CloseIcon from "../../../images/close-icon.svg"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import CarAdviseLogo from "../../../images/CarAdvise-Logo.svg"
import {
  DOORDASH,
  INSTACART,
  INSTACART_CA,
  INSTACART_CANADA,
  SHIPT,
  UBER,
  UBER_CA,
  UBER_CANADA,
  UBER_PARENT
} from "../../../v1/constants/affiliations"
import caShortLogo from "../../../images/ca-orange-short.svg"
import LeftArrowIcon from "../../../images/left_arrow_icon.svg"
import { APP_NAME } from "../../../shared_component/constants/common"
import SplitClient, { ON, Top10EToB } from "../../../v1/components/Config/SplitClient"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import { OIL_CHANGE } from "../../../v1/CarAdvise2/helpers/orderServiceHelpers"

const AffiliationWelcomeModal = ({
  user,
  openModal,
  closeModal,
  promotion,
  t,
  activeVehicleCart,
  activeVehicle
}) => {
  const [showContinueBookingBtn, setShowContinueBookingBtn] = useState(false)
  const [showTopCategoryService, setShowTopCategoryService] = useState(false)
  useEffect(async () => {
    const isSubscriptionFeatureFlag = await SplitClient.getTreatments([Top10EToB], user, {
      app_name: APP_NAME,
      sub_domain: getSubdomain()
    })
    setShowTopCategoryService(isSubscriptionFeatureFlag[Top10EToB] === ON)
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_open_first_time_welcome_modal
    })
  }, [])

  const closeWelcomeModal = (event) => {
    if (event) {
      trackFirebaseAnalytics({
        event: event
      })
    }
    closeModal()
  }

  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )

  let affiliationLogo = () => {
    return <Image className="caradvise-instacart-logo" src={CarAdviseLogo} alt="CarAdvise Logo" />
  }
  let promotionLogo = () => {
    return <Image src={caShortLogo} />
  }
  if (isInstacartUser) {
    affiliationLogo = () => (
      <Image
        className="caradvise-instacart-logo"
        src={CarAdviseInstacartLogo}
        alt="CarAdvise Instacart Logo"
      />
    )
    promotionLogo = () => <Image src={InstacartIcon} />
  }

  const getAffiliationName = () => {
    if (["a", "e", "i", "o", "u"].includes(user?.affiliation_name?.toLowerCase()?.charAt(0))) {
      return "an " + user?.affiliation_name
    } else {
      return "a " + user?.affiliation_name
    }
  }

  const getGigWorkerTerm = () => {
    if (
      [INSTACART, INSTACART_CANADA, INSTACART_CA, SHIPT].includes(
        user?.affiliation?.root_reference_id
      )
    ) {
      return t("shopper")
    }

    if ([UBER, UBER_CANADA, UBER_PARENT, UBER_CA].includes(user?.affiliation?.root_reference_id)) {
      return t("driver")
    }

    if ([DOORDASH].includes(user?.affiliation?.root_reference_id)) {
      return "Dashers"
    }

    return "User"
  }

  useEffect(() => {
    if (
      activeVehicleCart &&
      activeVehicleCart.order_services.length === 1 &&
      activeVehicleCart.order_services[0].reference_id === OIL_CHANGE
    ) {
      setShowContinueBookingBtn(true)
    } else {
      setShowContinueBookingBtn(false)
    }
  }, [activeVehicleCart])

  const discount = (promotion) => {
    switch (promotion.discount_type) {
      case "percent":
        return promotion.discount + "%"
      case "dollars":
        return "$" + promotion.discount / 100
    }
  }

  const offerServiceName = ({ service_definition_name }) =>
    service_definition_name ? `${t("one")} ${service_definition_name}` : t("aService")

  const instacartPromo = isInstacartUser
    ? promotion.find((p) => p.instacart_membership_discount)
    : null
  return (
    <Modal open={openModal} className={"instacart-welcome-modal"}>
      <Image
        src={CloseIcon}
        width="24px"
        height="24px"
        className="close-icon"
        onClick={() => {
          closeWelcomeModal(gaJSON.EtoB_close_first_time_welcome_modal)
        }}
      />
      <div className="instacart-welcome">
        {affiliationLogo()}
        <p className="hi-user">Hi, {user.firstName}</p>
        <p className="what-to-do">{t("whatDoYouWantToDo")}</p>
        <Link
          className="oil-change-btn"
          to={routerPaths.serviceRequest}
          onClick={() => {
            localStorage.setItem("isOilChangeService", true)
            localStorage.setItem("isComparePriceFlow", false)
            closeWelcomeModal(gaJSON.EtoB_book_oil_change)
          }}
        >
          {t("Schedule Oil Change")}
          {isInstacartUser && (
            <span className="benefit-label">
              <Image src={InstacartIcon} />
              {t("benefit")}
            </span>
          )}
          <Image className="left-arrow-icon" src={LeftArrowIcon} />
        </Link>
        {/* {showContinueBookingBtn && (
          <Link
            className="oil-change-btn"
            to={routerPaths.shopSelection}
            onClick={() => {
              localStorage.setItem("isOilChangeService", true)
              localStorage.setItem("isComparePriceFlow", false)
              closeWelcomeModal(gaJSON.EtoB_book_oil_change)
            }}
          >
            {t("vehicleDetails:continueBookingOilChange")}
            <Image className="left-arrow-icon" src={LeftArrowIcon} />
          </Link>
        )} */}
        {showTopCategoryService && (
          <Link
            className="oil-change-btn"
            to={routerPaths.serviceRequest}
            onClick={() => {
              localStorage.setItem("isOilChangeService", false)
              localStorage.setItem("isComparePriceFlow", false)
              closeWelcomeModal(gaJSON.EtoB_see_other_services)
            }}
          >
            {t("Schedule More Services")}
            <Image className="left-arrow-icon" src={LeftArrowIcon} />
          </Link>
        )}
        {!showTopCategoryService && (
          <Link
            className="oil-change-btn"
            to={routerPaths.addServices}
            onClick={() => {
              localStorage.setItem("isOilChangeService", false)
              localStorage.setItem("isComparePriceFlow", false)
              closeWelcomeModal(gaJSON.EtoB_see_other_services)
            }}
          >
            {t("bookOtherServices")}
            <Image className="left-arrow-icon" src={LeftArrowIcon} />
          </Link>
        )}
        {showTopCategoryService && !activeVehicle?.id && (
          <Link
            to={routerPaths.serviceRequest}
            className="explore-account"
            onClick={() => {
              localStorage.setItem("isOilChangeService", false)
              localStorage.setItem("isComparePriceFlow", true)
              closeWelcomeModal(gaJSON.EtoB_explore_my_account)
            }}
          >
            {t("comparePrices")}
          </Link>
        )}
        {instacartPromo && (
          <div className="instacart-diamond-member">
            {promotionLogo()}
            <div>
              <p className="oil-change-off">
                {t("enjoyOffOnService", {
                  discount: discount(instacartPromo),
                  serviceName: offerServiceName(instacartPromo),
                  affiliation: getAffiliationName(),
                  gigWorkerTerm: getGigWorkerTerm()
                })}
              </p>
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

function mapStateToProps(state) {
  const user = state.user || {}
  const promotion =
    state.promotionData.customerPromotions?.filter(
      (promotion) => promotion.service_definition_name === OIL_CHANGE
    ) || []
  const activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  const activeVehicleCart =
    user.activeVehicleId &&
    user.active_carts.find((cart) => cart.vehicle_id === user.activeVehicleId)
  return {
    user,
    promotion,
    activeVehicleCart,
    activeVehicle
  }
}

export default connect(mapStateToProps)(
  withTranslation(["welcomeModal", "vehicleDetails"])(AffiliationWelcomeModal)
)
